import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: 19;
    top: 0;
    left: 50%;
    flex-direction: column;
    width: 100%;
    max-width: ${breakpoint.mobile_large};
    height: 100%;
    transform: translateX(-50%);
    background: ${theme.backgroundColor.base};
  `}
`;

export const Inner = styled.div`
  width: 100%;
  height: 100%;
`;

export const ModalHeader = styled.header`
  display: flex;
  position: fixed;
  z-index: 20;
  top: 0;
  left: 50%;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  margin: 0 auto;
  transform: translateX(-50%);
`;

export const VideoCallWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  height: calc(100% - 112px);
`;

export const VideoButtonWrapper = styled.div`
  display: block;
  height: 112px;
  padding: 16px 0;
`;

export const BackgroundBox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 0 0 16px 16px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `}
`;

export const UserImageBox = styled.div`
  ${({ theme }) => css`
    display: block;
    position: absolute;
    right: ${theme.layout.section_side};
    bottom: calc(8px * 2 + 65px);
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 12px;

    & > div {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
    }
  `}
`;

export const SubscribeButtonBox = styled.div`
  ${({ theme }) => css`
    display: block;
    position: absolute;
    bottom: 8px;
    width: 100%;
    padding: 0 ${theme.layout.section_side};
  `}
`;

export const SubscribeButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 65px;
    border-radius: 16px;
    background: ${theme.themeColor.main_1};

    & > strong {
      display: block;
      ${theme.fontStyle.text.body18_bold}
      color: ${theme.content.content_dark_1};
    }

    & > span {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.content_dark_3_alpha};
    }
  `}
`;

export const VideoCallButtonBox = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
`;

export const CallButton = styled.li`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    & > span {
      display: block;
      ${theme.fontStyle.text.body16_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const IconBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border: 1px solid ${theme.backgroundColor.bg_light_5_alpha};
    border-radius: 50%;

    &.red {
      background: ${theme.themeColor.negative};
    }
  `}
`;
